import React, { useState, useEffect } from "react";
import "../../style/HomePageTopBar.css"; // ✅ Ensure correct CSS import
import Logo from "../assets/logo2.png"; // ✅ Ensure logo exists
import SearchIcon from "@mui/icons-material/Search";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import SettingsIcon from "@mui/icons-material/Settings"; // ✅ Import settings icon
import LogoutIcon from "@mui/icons-material/ExitToApp";

import { styled, alpha } from "@mui/material/styles";
import {
  MenuItem,
  Select,
  FormControl,
  Avatar,
  InputBase,
} from "@mui/material";
import { useNavigate } from "react-router-dom"; // ✅ Used for navigation
import { useAuth } from "../../AuthContext";

const API_BASE_URL = process.env.REACT_APP_API_SOURCE;

const Search = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  position: "relative",
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": { backgroundColor: alpha(theme.palette.common.white, 0.25) },
  marginLeft: "20px",
  width: "auto",
  border: "1px solid #ccc",
  borderRadius: "4px",
  paddingRight: "10px",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  flexGrow: 1,
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 2),
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": { width: "20ch" },
    },
  },
}));

const TopBar = () => {
  const navigate = useNavigate();
  const { username, logout, userId, profilePicture } = useAuth(); // ✅ Use username from AuthContext.js
  const [filter, setFilter] = useState(
    localStorage.getItem("selectedFilter") || ""
  );
  const [showDropdown, setShowDropdown] = useState(false); // ✅ Dropdown toggle state
  const [showNotifications, setShowNotifications] = useState(false); // ✅ State for notification panel

  const handleFilterChange = (event) => {
    const newFilter = event.target.value;
    setFilter(newFilter);
    localStorage.setItem("selectedFilter", newFilter);
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="TopBar">
      {/* 🔹 Click Logo to Navigate to Homepage */}
      <img
        src={Logo}
        alt="Logo"
        className="logo"
        onClick={() => navigate("/home")}
        style={{ cursor: "pointer" }}
      />

      {/* <Search> */}
      {/* <FormControl size="small"> */}
      {/* You can uncomment and use the Select if needed */}
      {/* <Select value={filter} onChange={handleFilterChange} displayEmpty>
            <MenuItem value="">All</MenuItem>
            <MenuItem value="option1">Applied</MenuItem>
            <MenuItem value="option2">Interview</MenuItem>
            <MenuItem value="option3">Job Applied</MenuItem>
          </Select> */}
      {/* </FormControl>
        <StyledInputBase placeholder="Search…" />
        <SearchIcon style={{ cursor: "pointer" }} />
      </Search> */}

      <div
        className="RightSection"
        style={{ display: "flex", alignItems: "center", position: "relative" }}
      >
        {/* 🔹 Notification Icon */}
        <div
          className="notification-icon"
          onClick={() => setShowNotifications(!showNotifications)}
        >
          <NotificationsNoneOutlinedIcon fontSize="large" />
          {showNotifications && (
            <div className="notification-panel">
              <p>
                <strong>Notifications</strong>
              </p>
              <ul>
                <li>🔹 New interview scheduled</li>
                <li>✅ Application accepted</li>
                <li>❌ Rejection from Company X</li>
              </ul>
            </div>
          )}
        </div>

        {/* 🔹 Display Username */}
        {username && (
          <span
            className="username-display"
            style={{ marginRight: "12px", fontWeight: "bold" }}
          >
            {username}
          </span>
        )}

        {/* 🔹 Profile Avatar */}
        <div className="user-avatar-container">
          <Avatar
            src={
              profilePicture
                ? profilePicture
                : `${API_BASE_URL}/backend/profileUploads/default_profile.png`
            }
            alt="User"
            onClick={() => setShowDropdown(!showDropdown)}
            className="user-avatar"
          />

          {showDropdown && (
            <div className="dropdown-menu">
              <div
                className="dropdown-item"
                onClick={() => navigate("/settings")}
              >
                <SettingsIcon className="dropdown-icon" />
                Settings
              </div>
              <div className="dropdown-item logout" onClick={handleLogout}>
                <LogoutIcon className="dropdown-icon" />
                Sign Out
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
